import { cn } from "@/packages/utils";
import { Check } from "lucide-react";
import {
  getCategoryLucideIcon,
  getAvailableIconNames,
} from "./category-icon-map";

interface LucideIconPickerProps {
  selectedIcon: string;
  onSelect: (iconName: string) => void;
}

export function LucideIconPicker({
  selectedIcon,
  onSelect,
}: LucideIconPickerProps) {
  const iconNames = getAvailableIconNames();

  return (
    <div className="grid grid-cols-5 gap-2">
      {iconNames.map((iconName) => {
        const IconComponent = getCategoryLucideIcon(iconName);
        if (!IconComponent) return null;

        const isSelected = selectedIcon === iconName;

        return (
          <button
            key={iconName}
            type="button"
            onClick={() => onSelect(iconName)}
            className={cn(
              "relative flex h-12 w-12 items-center justify-center rounded-md border transition-colors",
              isSelected
                ? "border-primary bg-primary/10 text-primary"
                : "border-border hover:border-primary/50 hover:bg-muted",
            )}
            title={iconName}
          >
            <IconComponent className="h-5 w-5" />
            {isSelected && (
              <div className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary">
                <Check className="h-3 w-3 text-primary-foreground" />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
